import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import CurrencyFormat from "react-currency-format";
import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  InputGroupAddon,
  InputGroup,
  Col,
  Alert,
} from "reactstrap";
import { useHistory, useParams } from "react-router-dom";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import { JobService } from "../../../../services/JobService";
import "react-multiple-select-dropdown-lite/dist/index.css";
import { getEnumLists } from "../../../../services/MetadataService";
import { allContacts, getContactsService, getLocationContactService, getLocationService, showAccountsService } from "../../../../services/AccountService";
import { isNullOrEmpty } from "../../../../config/ENV";
import { GrSettingsOption } from "react-icons/gr";
import { BsFillEyeFill } from "react-icons/bs";
import { AiOutlineCaretDown } from "react-icons/ai";
import "../../../../assets/css/toggle.css";
import { TemplateService } from "../../../../services/TemplateService";
import Linkify from "react-linkify";
import { formattedMobileNumber } from "../../../../utilities/phonenumberutility";
import JobBoardPost from "./jobboardpost";
import {
  MdOutlineArrowBackIosNew,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import JobReqLocation from "./jobreqlocation";
import HiringManagerContacts from "./HiringManagerContacts";
import HiringCoordinatorContacts from "./HiringCoordinatorContacts";

toast.configure();
const quillModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const BasicInformation = (props) => {
  const history = useHistory();
  var { id } = useParams();
  // const [talentA,showTa]=useState()
  const [modalRight, setModalRight] = useState(false);
  const [baseModalright,setBaseModalRight] =useState(false)
  const [modalRight1, setModalRight1] = useState(false);
  const [modalRight2, setModalRight2] = useState(false);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [jobPriorityOptions, setJobPriorityOptions] = useState([]);
  const [salaryTypeOptions, setSalaryTypeOptions] = useState([]);
  const [billingRateTypes, setBillingRateTypes] = useState([]);
  const [jobTypeOptions, setJobTypeOptions] = useState([]);
  const [durationTypesoptions, setdurationTypesoptions] = useState([]);
  const [jobShiftOptions, setJobShiftOptions] = useState([]);
  const [jobRemoteWorkOptions, setJobRemoteWorkOptions] = useState([]);
  const [empTermOptions, setEmpTermOptions] = useState([]);
  const [workModelOptions, setWorkModelOptions] = useState([]);
  const [workStatus, setWorkStatus] = useState("ON_SITE");
  const [aboutJobOptions, setAboutJobOptions] = useState([]);
  const [billingRate, setBillingRate] = useState(0);
  const [additionalPayInfo, setAdditionalPayInfo] = useState();
  const [customAddress, setCustomAddress] = useState([]);
  const [talentAdvisor, setTalentAdvisor] = useState([]);
  const [loginTa, setLoginTa] = useState([]);
  const [taId, setTAId] = useState("");
  const [taIds, setTAIds] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState("");
  const [accountLocation, setAccountLocation] = useState([]);
  const [showLocation, setShowLocation] = useState(false);
  const [accountBenefits, setAccountBenefits] = useState([]);
  const [locationId, setLocationId] = useState("");
  const [benefitsId, setBenefitId] = useState("");
  const [ contactId,setcontactId] = useState("");
  const [remoteLocation, setRemoteLocation] = useState(false);
  const [location, setLocation] = useState("");
  const [accountJobDetails, setAccountJobDetails] = useState([]);
  const [durationType, setDurationType] = useState("DAY");
  const [selectedJobTemplateName, setSelectedJobTemplateName] = useState("");
  const [OpentextArea, isOpentextArea] = useState(false);
 const [locationContacts,setLocationContacts] = useState([])
  const [newList, setNewList] = useState([]);
const[createdJobId,setCreatedJobId]=useState(id)
  const [inputField, setInputField] = useState({
    jobId: "",
    jobTitle: "",
    publicTitle: "",
    referenceId: "",
    lpName: "",
    addTo: "",
    salaryMin: 0,
    salaryMax: 0,
    // billingRate: '',
    duration: "",
    notes: "",
    lpUrl: "",
  });
  const [address, setAddress] = useState({
    street: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pinCode: "",
  });

  const [automaticFilterField, setAutomaticFilterField] = useState({
    minSkillFit: "",
    minPreFit: "",
    minYearsWorked: "",
  });

  const [skillsFlavor, setSkillsFlavor] = useState("General Cricle");
  const [hiringModel, setHiringModel] = useState("Small Office");
  const [showPay, setShowPay] = useState(true);
  const [displayAccInfo,setDisplayAccInfo]=useState(true);
  const [jobStatus, setJobStatus] = useState("OPPORTUNITY");
  const [jobReqStatus, setJobReqStatus] = useState("Opportunity");
  const [priority, setPriority] = useState("MEDIUM");
  const [salaryType, setSalaryType] = useState("ANNUAL");
  const [jobType, setJobType] = useState("FULL_TIME");
  const [empTerm, setEmpTerm] = useState("DIRECT_HIRE");
  const [jobShift, setJobShift] = useState("DAY");
  const [remoteWork, setRemoteWork] = useState("NEVER");
  const [aboutJob, setAboutJob] = useState("GENERATED");
  const [billingType, setBillingType] = useState("ANNUAL");
  const [schedule, setSchedule] = useState([]);

  const [jobDescription, setJobDescription] = useState("");
  const [jobResponsibilities, setJobResponsibilities] = useState("");
  const [jobRequirements, setJobRequirements] = useState("");
  const [accountId, setAccountId] = useState("");
  const [contactDetails,setContactDetails]=useState([]);
  const [selectedContact,setSelectedContact]=useState({});

  const [selectedHiringManagerContact,setSelectedHiringManagerContact]=useState({});

  const [contactView,setContactView]=useState(false)
  const [selectedContactId,setSelectedContactId]=useState("");
  const[coordinatorContact,setCoordinatorContact] =useState("");
  const [candidateJobDescription, setCandidateJobDescription] = useState("");
  const [candidateJobResponsibilities, setCandidateJobResponsibilities] =useState("");
  const [candidateJobRequirements, setCandidateJobRequirements] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [notesList, setNotesList] = useState([]);
  const [size, setSize] = useState();
  const [overrideJobType, setOverrideJobType] = useState("FULL_TIME");
  const [overridedurationTypes, setoverridedurationTypes] = useState("DAY");
  const [overrideEmpTerm, setOverrideEmpTerm] = useState("DIRECT_HIRE");
  const [overJobShift, setOverJobShift] = useState("DAY");
  const [locationView, setLocationView] = useState(false);
  const [benefitsView, setBenefitsView] = useState(false);
  const [locationContactsView,setLocationContactsView] = useState(false);
  const [requestId, setrequestId] = useState("");
  const [salaryMin, setSalaryMin] = useState();
  const [salaryMax, setSalaryMax] = useState();
  const [userId, setUserId] = useState("");
  const [scheduleType, setScheduleType] = useState([
    { label: "SUNDAY", value: "1" },
    { label: "MONDAY", value: "2" },
    { label: "TUESDAY", value: "3" },
    { label: "WEDNESDAY", value: "4" },
    { label: "THURSDAY", value: "5" },
    { label: "FRIDAY", value: "6" },
    { label: "SATURDAY", value: "7" },
  ]);
  const [schedules, setSchedules] = useState([]);
  const [templates, setTemplates] = useState([]);

  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [templateFields, setTemplateFields] = useState([]);
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [ accountContactDetail,setAccountContactDetail] = useState([])
  const [jobBoards, setJobBoards] = useState([]);
  const [selectedJobBoardId, setSelectedJobBoardId] = useState("");
  const [selectedJobBoardName, setSelectedJobBoardName] = useState("");
  const [jobBoardPostsUpdate, setJobBoardPostsUpdate] = useState([]);
  const [postText, setPostText] = useState("");
  const [jobBoardPost, setJobBoardPost] = useState([]);
  const [jobBoardName,setJobBoardName]=useState([]);

  const [jobDetailsAccountId,setJobDetailsAccountId]=useState('');
  const [selectedHiringManagerContactId,setSelectedHiringManagerContactId]=useState({});
  const [hiringManagerContactsView,setHiringManagerContactsView] = useState(false);

  const [selectedHiringCoordinatorContact,setSelectedHiringCoordinatorContact]=useState({});
  const [selectedHiringCoordinatorContactId,setSelectedHiringCoordinatorContactId]=useState('');
  const [hiringCoordinatorContactsView,setHiringCoordinatorContactsView] = useState(false);
  const [accountContactsList,setAccountContactsList] = useState([])

  const jobDescriptionFunction = () => {
    setJobDescription(candidateJobDescription);
  };

  const jobResponsibilitiesFunction = () => {
    setJobResponsibilities(candidateJobResponsibilities);
  };

  const jobRequirementsFunction = () => {
    setJobRequirements(candidateJobRequirements);
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;

    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

const jobBoardPostFunction=(jobBoardList)=>
{

  setJobBoardPostsUpdate(jobBoardList);
}


const jobReqlocationpost=(selectedLocationContactId)=>{
  if(selectedLocationContactId == "Select Location Contact"){
    setSelectedContactId("");
  }
  else{
    setSelectedContactId(selectedLocationContactId);
  }
  for(var i=0;i<locationContacts.length;i++){
    if(locationContacts[i].id===selectedLocationContactId){
      setSelectedContact(locationContacts[i])
    }
   }
}

const jobReqHiringManagerPost=(selectedHiringManagerContactId)=>{
  if(selectedHiringManagerContactId == "Select Location Contact"){
   setSelectedHiringManagerContactId('');
   setHiringManagerContactsView(false)
  }else{

    setSelectedHiringManagerContactId(selectedHiringManagerContactId);
    setHiringManagerContactsView(true);    
  }

  for(var i=0;i<accountContactsList.length;i++){


    let contactList = accountContactsList[i].contacts
for(var j=0;j<contactList.length;j++){

    if(contactList[j].id===selectedHiringManagerContactId){
      setSelectedHiringManagerContact(contactList[j])
    }
   }
}
}

const jobReqHiringCoordinatorPost=(selectedHiringCoordinatorContactId)=>{
  if(selectedHiringCoordinatorContactId == "Select Location Contact"){
   setSelectedHiringCoordinatorContactId("");
   setHiringCoordinatorContactsView(false)
  }else{
    setSelectedHiringCoordinatorContactId(selectedHiringCoordinatorContactId);
    setHiringCoordinatorContactsView(true)
  }

  for(var i=0;i<accountContactsList.length;i++){

    let ContactsList = accountContactsList[i].contacts


    for(var j=0;j<ContactsList.length;j++){

    

    if(ContactsList[j].id===selectedHiringCoordinatorContactId){

      setSelectedHiringCoordinatorContact(ContactsList[j])
    }
   }
  }
}

  const sortSchedules = (schedules) => {
    var sortedSchedules = [];
    for (var i = 0; i < schedules.length; i++) {
      var schedule = {
        label: schedules[i],
      };

      for (var j = 0; j < scheduleType.length; j++) {
        if (scheduleType[j].label == schedule.label) {
          schedule.value = scheduleType[j].value;
          schedule.label = scheduleType[j].label;
        }
      }
      sortedSchedules.push(schedule);
    }
    sortedSchedules.sort((a, b) => a.value.localeCompare(b.value));
    setSchedule(sortedSchedules);
  };

  let count = 0;

  useEffect(() => {

    if (!isNullOrEmpty(localStorage.getItem("userobject"))) {
      var user = JSON.parse(localStorage.getItem("userobject"));
      setUserId(user.id);
    }

    if (id != 0) {
      setDisplayAccInfo(false);
      setShowPay(false);
      getJobDetails(id);
      getStatusHistory();
    } else {
      getTalentAdvisors();
      getAllAccounts("");
      getJobEnums("");
      setShowPay(true);
      setDisplayAccInfo(true);
      getAllTemplates("", []);
    }
  }, [count]);

  const getStatusHistory = () => {
    const jobId = window.localStorage.getItem("requestId");
    JobService.getDisplayNotes(jobId).then((response) => {
      if (response.status === 200) {
        setNotesList(response.data.jobStatusHistory);
        setSize(response.data.size);
      }
    });
  };

  const getJobDetails = (jobId) => {
    let landingPageTemplate = "";
    let landingPageTemplateFields = [];
    let JobBoardposts = [];
    try {
      var jobDetails = props.jobDetails;
      if (jobDetails != null) {
        setAccountJobDetails(jobDetails);
        if (jobDetails.talentAdvisor !== null) {
          setTAId(jobDetails.talentAdvisor.id);
          getTalentAdvisors();
        } else {
          getTalentAdvisors();
        }

        if (!isNullOrEmpty(jobDetails.accountId)) {
          getAllAccounts(jobDetails.accountId);
        } else {
          getAllAccounts("");
        }

        if (jobDetails.jobType !== null) {
          setOverrideJobType(jobDetails.jobType.key);
          setJobType(jobDetails.jobType.key);
        }
        let hiringManagerContactId="";
        let hiringManagerContact=jobDetails.hiringManagerContact;

        if(hiringManagerContact!=null){          
           hiringManagerContactId=hiringManagerContact.id;
           if(!isNullOrEmpty(hiringManagerContactId)){
              setSelectedContactId(hiringManagerContactId)
              setSelectedHiringManagerContactId(hiringManagerContactId);
              setHiringManagerContactsView(true)
           }else{
            setSelectedContactId('')
            hiringManagerContactId='';
            setSelectedHiringManagerContactId('');
            setHiringManagerContactsView(false)
           }         
        }else{
          setSelectedHiringManagerContactId('');
        }

        let hiringCoordinatorContactId="";
        let hiringCoordinatorContact=jobDetails.hiringCoordinatorContact;
        if(hiringCoordinatorContact!=null){
            hiringCoordinatorContactId=hiringCoordinatorContact.id;
           if(!isNullOrEmpty(hiringCoordinatorContactId)){   
              setCoordinatorContact(hiringCoordinatorContactId)
              setSelectedHiringCoordinatorContactId(hiringCoordinatorContactId)
              setHiringCoordinatorContactsView(true)
           }else{
            setCoordinatorContact('')
            hiringCoordinatorContactId='';
            setSelectedHiringCoordinatorContactId('')
             setHiringCoordinatorContactsView(false)
           }
        }else{
          setSelectedHiringCoordinatorContactId('')
        }

        if (jobDetails.durationType != null) {
          getJobEnums(jobDetails.durationType.key);
        } else {
          getJobEnums("");
        }

        if (!isNullOrEmpty(jobDetails.jobId)) {
          setrequestId(jobDetails.jobId);
          setInputField((prevState) => ({
            ...prevState,
            jobId: jobDetails.jobId,
          }));
        }

        if (!isNullOrEmpty(jobDetails.jobTitle)) {
          setInputField((prevState) => ({
            ...prevState,
            jobTitle: jobDetails.jobTitle,
          }));
        }

        if (!isNullOrEmpty(jobDetails.publicTitle)) {
          setInputField((prevState) => ({
            ...prevState,
            publicTitle: jobDetails.publicTitle,
          }));
        }

        if (!isNullOrEmpty(jobDetails.referenceId)) {
          setInputField((prevState) => ({
            ...prevState,
            referenceId: jobDetails.referenceId,
          }));
        }

        if (!isNullOrEmpty(jobDetails.skillsFlavor)) {
          setSkillsFlavor(jobDetails.skillsFlavor);
        }

        if (!isNullOrEmpty(jobDetails.hiringModel)) {
          setHiringModel(jobDetails.hiringModel);
        }

        if (!isNullOrEmpty(jobDetails.showPay)) {
          setShowPay(jobDetails.showPay);
        }

        if(!isNullOrEmpty(jobDetails.displayAccountInfo)){
          setDisplayAccInfo(jobDetails.displayAccountInfo);
        }

        if (!isNullOrEmpty(jobDetails.durationType)) {
          setDurationType(jobDetails.durationType.key);
        }
        if (!isNullOrEmpty(jobDetails.empTerm)) {
          setEmpTerm(jobDetails.empTerm.key);
        }

        if (!isNullOrEmpty(jobDetails.addTo)) {
          setInputField((prevState) => ({
            ...prevState,
            addTo: jobDetails.addTo,
          }));
        }
        if (jobDetails.jobStatus != null) {
          setJobStatus(jobDetails.jobStatus.key);
          setJobReqStatus(jobDetails.jobStatus.value);
        }

        if (jobDetails.priority != null) {
          setPriority(jobDetails.priority.key);
        }

        if (!isNullOrEmpty(jobDetails.salaryMin)) {
          if (jobDetails.salaryMin !== 0) {
            setSalaryMin(jobDetails.salaryMin);
          }
        }

        if (!isNullOrEmpty(jobDetails.salaryMax)) {
          if (jobDetails.salaryMax !== 0) {
            setSalaryMax(jobDetails.salaryMax);
          }
        }

        if (!isNullOrEmpty(jobDetails.notes)) {
          setInputField((prevState) => ({
            ...prevState,
            notes: jobDetails.notes,
          }));
        }

        if (!isNullOrEmpty(jobDetails.lpUrl)) {
          setInputField((prevState) => ({
            ...prevState,
            lpUrl: jobDetails.lpUrl,
          }));
        }

        if (jobDetails.salaryType !== null) {
          setSalaryType(jobDetails.salaryType.key);
        }

        if (!isNullOrEmpty(jobDetails.billingRate)) {
          setBillingRate(jobDetails.billingRate);
        }

        if (jobDetails.billingRateType !== null) {
          setBillingType(jobDetails.billingRateType.key);
        }
        if (!isNullOrEmpty(jobDetails.additionalPayInfo)) {
          setAdditionalPayInfo(jobDetails.additionalPayInfo);
        }

        if (!isNullOrEmpty(jobDetails.duration)) {
          setInputField((prevState) => ({
            ...prevState,
            duration: jobDetails.duration,
          }));
        }

        if (jobDetails.schedule != null) {
          sortSchedules(jobDetails.schedule);
        }

        if (jobDetails.jobShift !== null) {
          setJobShift(jobDetails.jobShift.key);
          setOverJobShift(jobDetails.jobShift.key);
        }

        if (!isNullOrEmpty(jobDetails.accountId)) {
          setAccountId(jobDetails.accountId);
          getAccountLocation(jobDetails.accountId);
          setShowLocation(true);
          setLocationContactsView(true)

          setJobDetailsAccountId(jobDetails.accountId);
          getAccountContacts(jobDetails.accountId,hiringManagerContactId,hiringCoordinatorContactId)       

        }

        if (!isNullOrEmpty(jobDetails.locationId)) {
          setLocationId(jobDetails.locationId);
          setLocation(jobDetails.locationId);
          setLocationView(true);
          setLocationContactsView(true);
          getContacts(jobDetails.accountId, jobDetails.locationId)
        } else {
          if (jobDetails.remoteLocation === true) {
            setLocationContactsView(true)
            setLocationView(false);
            setLocation("Remote Location");
            getAccountContacts(jobDetails.accountId)
          }
        }

        if (jobDetails.jobBenefits != null) {
          if (isNullOrEmpty(jobDetails.jobBenefits.id)) {
           
            setBenefitId("");
          } else {
            setBenefitId(jobDetails.jobBenefits.id);
            setBenefitsView(true);
          }
        }
        if (!isNullOrEmpty(jobDetails.accountContact) ) {          
          if (isNullOrEmpty(jobDetails.accountContact.id)) {          
            setSelectedContactId("");
          } else {
            setSelectedContactId(jobDetails.accountContact.id);
            setSelectedContact(jobDetails.accountContact)
            // setBenefitsView(true);
          }
        }
        if (jobDetails.remoteWork !== null || jobDetails.remoteWork !== "") {
          setRemoteWork(jobDetails.remoteWork.key);
        }
        if (!isNullOrEmpty(jobDetails.workStatus)) {
          setWorkStatus(jobDetails.workStatus.key);
        }
        if (jobDetails.address !== null || jobDetails.address !== "") {
          setAddress(jobDetails.address);
        }
        if (jobDetails.aboutJob !== null || jobDetails.aboutJob !== "") {
          setAboutJob(jobDetails.aboutJob.key);
        }

        if (!isNullOrEmpty(jobDetails.jobDescription)) {
          setJobDescription(jobDetails.jobDescription);
          setCandidateJobDescription(jobDetails.jobDescription);
        }

        if (!isNullOrEmpty(jobDetails.jobResponsibilities)) {
          setJobResponsibilities(jobDetails.jobResponsibilities);
          setCandidateJobResponsibilities(jobDetails.jobResponsibilities);
        }

        if (!isNullOrEmpty(jobDetails.jobRequirements)) {
          setJobRequirements(jobDetails.jobRequirements);
          setCandidateJobRequirements(jobDetails.jobRequirements);
        }

        if (!isNullOrEmpty(jobDetails.jobBoardPost)) {
          setJobBoardPost(jobDetails.jobBoardPost);
        }

        if (jobDetails.empTerm !== null) {
          setOverrideEmpTerm(jobDetails.empTerm.key);
        }

        if (jobDetails.automaticFilter !== null) {
          if (!isNullOrEmpty(jobDetails.automaticFilter.minSkillFit)) {
            setAutomaticFilterField((prevState) => ({
              ...prevState,
              minSkillFit: jobDetails.automaticFilter.minSkillFit,
            }));
          }

          if (!isNullOrEmpty(jobDetails.automaticFilter.minPreFit)) {
            setAutomaticFilterField((prevState) => ({
              ...prevState,
              minPreFit: jobDetails.automaticFilter.minPreFit,
            }));
          }

          if (!isNullOrEmpty(jobDetails.automaticFilter.minYearsWorked)) {
            setAutomaticFilterField((prevState) => ({
              ...prevState,
              minYearsWorked: jobDetails.automaticFilter.minYearsWorked,
            }));
          }
        }

        if (jobDetails.remoteLocation) {
          setRemoteLocation(jobDetails.remoteLocation);
          setLocation("Remote Location");
        }

        if (!isNullOrEmpty(jobDetails.landingPageTemplate)) {
          landingPageTemplate = jobDetails.landingPageTemplate;
          setSelectedJobTemplateName(landingPageTemplate);
          setSelectedTemplateName(landingPageTemplate);
        }

        if (jobDetails.landingPageFields !== null) {
          landingPageTemplateFields = jobDetails.landingPageFields;
        }
        if (jobDetails.jobBoardPosts !== null) {
          JobBoardposts = jobDetails.jobBoardPosts;
         
          if (JobBoardposts !== null) {
            setJobBoardPostsUpdate(JobBoardposts);
          }
        }

      


      }
    } catch (err) {
      console.log("message" + JSON.stringify(err.message));
    }
    getAllTemplates(
      landingPageTemplate,
      landingPageTemplateFields,
      JobBoardposts
    );
  };

  let count1 = 0;

  const getAllAccounts = (accountId) => {
    showAccountsService(search).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
            console.log("error" + JSON.stringify(response.data.error_message));
          }
        } else {
          if (response.data !== null) {
            setAccounts(response.data.accounts);
            setAccountId(accountId);
          }
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };

  const getTalentAdvisors = () => {
    JobService.getActiveTAService().then((response) => {
      try {
        if (response.data !== null) {
          filterTAs(response.data.members);
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };

  const getAllTemplates = (landingPageTemplate, landingPageTemplateFields) => {
    TemplateService.showTemplatesService("").then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
            console.log("error" + JSON.stringify(response.data.error_message));
          }
        } else {
          if (response.data !== null) {
            let templates = response.data.templates;
            if (templates !== null) {
              if (templates.length > 0) {
                // setTemplates(templates);
                updateTemplate(
                  templates,
                  landingPageTemplate,
                  landingPageTemplateFields
                );
              } else {
                setTemplates([]);
              }
            } else {
              setTemplates([]);
            }
          }
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };


  const updateTemplate = (
    templates,
    landingPageTemplate,
    landingPageTemplateFields
  ) => {
    templates.map((tempate) => {
      tempate.value = "";
    });

    if (!isNullOrEmpty(landingPageTemplate)) {
      setSelectedJobTemplateName(landingPageTemplate);
    }

    if (landingPageTemplateFields.length > 0) {
      templates.map((template) => {
        let templateName = template.name;
        if (templateName == landingPageTemplate) {
          let templateFields = template.fields;
          if (templateFields.length > 0) {
            templateFields.map((templateField) => {
              let templateFieldName = templateField.name;
              const isFound = landingPageTemplateFields.some((element) => {
                if (element.name === templateFieldName) {
                  return true;
                }
                return false;
              });
              if (isFound) {
                setTemplateFields(templateFields);
                landingPageTemplateFields.map((landingPageTemplateField) => {
                  if (landingPageTemplateField.name == templateFieldName) {
                    templateField.value = landingPageTemplateField.value;
                  }
                });
              }
            });
          }
        }
      });
    }
    setTemplates(templates);
  };

  const filterTAs = (taList) => {
    setLoginTa([]);
    if (taList.length > 0) {
      var ta = [];

      taList.map((tas, i) => {
        if (userId !== tas.id) {
          if (!isNullOrEmpty(tas.displayName)) {
            ta.push({ label: `${tas.displayName}`, value: `${tas.id}` });
          }
        } else {
          if (!isNullOrEmpty(tas.displayName)) {
            loginTa.push({ label: `${tas.displayName}`, value: `${tas.id}` });
            setLoginTa(loginTa);
            ta.push({ label: `${tas.displayName}`, value: `${tas.id}` });
          }
        }
      });
      setTalentAdvisor(ta);
    }
  };

  const getGeneratedJobId = () => {
    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    JobService.generateJobId(accountId).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
            console.log("error" + JSON.stringify(response.data.error_message));
          }
        } else {
          if (response.data !== null) {
            setInputField((prevState) => ({
              ...prevState,
              jobId: response.data.shortCode,
            }));
          }
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };
  const getAccountLocation = (id) => {
   
    if (!isNullOrEmpty(id)) {
      JobService.getAccountLocationsService(id).then((response) => {
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
              console.log(
                "error" + JSON.stringify(response.data.error_message)
              );
            }
          } else {
            if (response.data !== null) {
              if (response.data.accountAddress.length > 0) {
                setAccountLocation(response.data.accountAddress);
              } else {
                setAccountLocation([]);
              }

              if (response.data.accountBenefits.length > 0) {
                setAccountBenefits(response.data.accountBenefits);
              } else {
                setAccountBenefits([]);
              }
            }
          }
        } catch (err) {
          console.log("error" + JSON.stringify(err.message));
        }
      });
    }
  };

  const getContacts = (accountId,locationid) => {
   getLocationContactService(accountId,locationid,"",50,1,"firstName","asc").then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          
          if (response.data !== null) {
            var data = response.data;
            var list = data.accountContacts
            // getAddresses();          
            setLocationContacts(list);
            
            // setContactView(true)
            for( var i=0;i<list.length;i++){
              if (list[i].primaryContact == true ){
                setSelectedContact(list[i])
                setSelectedContactId(list[i].id)               
              }
            }            
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
     
    });
  };

  const getAccountContacts = (id,hiringManagerContactId,hiringCoordinatorContactId) => { 
    allContacts(
      id
    ).then((response) => {
      
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data !== null) {
            var accountContact = response.data;      
            let accountContacts=accountContact.accountContacts;
            if(accountContacts!=null){
              if(accountContacts.length>0){
                for(let i=0;i<accountContacts.length;i++){  

                 let  Contacts = accountContacts[i].contacts
                  for(let j=0;j<Contacts.length;j++){
                  
                  let account=Contacts[j];

                  let accountId= account.id;
                  if(!isNullOrEmpty(hiringManagerContactId)){
                    

                    if(accountId==hiringManagerContactId){
                    
                      setSelectedHiringManagerContact(account);

                    }
                  }
                 
                  if(!isNullOrEmpty(hiringCoordinatorContactId)){
                    if(accountId==hiringCoordinatorContactId){

                      setSelectedContact(account);
                      setSelectedHiringCoordinatorContact(account);
                    }
                  }                
                }
                setLocationContacts(accountContacts);  
                 setAccountContactsList(accountContacts);
              
              }}
              
              
              
              else{
                setLocationContacts([]);  
                setAccountContactsList([]);
              }
            }else{
              setLocationContacts([]);  
              setAccountContactsList([]);  
            }             

            setLocationContactsView(true)           

          //  }else{
           //   setLocationContactsView(false)
           // }        
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };








  const handleScheduleClick = (event) => {
    event.sort((a, b) => a.value.localeCompare(b.value));

    setSchedule(event);
  };

  function handleHiringModelSelectChange(e) {
    setHiringModel(e.target.value);
  }
  function handleShowPaySelectChange(e) {
    setShowPay(!showPay);
  }
  function handleDisplayAccSelectChange(e) {
    setDisplayAccInfo(!displayAccInfo);
  }
  function handleJobStatusSelectChange(e, key) {
    setJobStatus(e.target.value);
  }
  function handlePrioritySelectChange(e) {
    setPriority(e.target.value);
  }
  function handleSlaryTypeSelectChange(e) {
    setSalaryType(e.target.value);
  }
  function handleBillingTypeSelectChange(e) {
    setBillingType(e.target.value);
  }
  function handleJobTypeSelectChange(e) {
    setJobType(e.target.value);
  }
  function handledurationtypeSelectChange(e) {
    setDurationType(e.target.value);
  }

  function handleEmployeementTermSelectChange(e) {
    setEmpTerm(e.target.value);
  }
  function handleJobShiftSelectChange(e) {
    setJobShift(e.target.value);
  }
  function handleWorkModelChange(e) {
    setWorkStatus(e.target.value);
  }
  function handleAboutJobSelectChange(e) {
    setAboutJob(e.target.value);
  }

  function handleTAChange(e) {
    setLoginTa([]);
    setTAIds([]);
    setTAId(e.target.value);
  }

  function handleBillingRate(e) {
    const bRate = e.target.value;
    const number = bRate.replace(/\$|,|/g, "");
    if (number != "") {
      setBillingRate(number);
    } else {
      setBillingRate(bRate);
    }
  }
  function handleAdditionalPayInfo(e) {
    setAdditionalPayInfo(e.target.value);
  }
  function handleAccountChange(e) {
   let accountId=e.target.value;
   setJobDetailsAccountId(accountId);

   setInputField((prevState) => ({
      ...prevState,
      jobId: "",
    }));

    if (e.target.value !== "select Account") {
      setAccountId(e.target.value);
      getAccountLocation(e.target.value);
      setShowLocation(true);
      setLocationView(false);
      setLocationContactsView(false);
      setBenefitsView(false);
      
      // setContactDetails()
    } else {
      
      setAccountId("");
      setLocation("");
      setLocationId("");
      setBenefitId("");

      setLocationView(false);
      setShowLocation(false);
      setBenefitsView(false);
      setLocationContactsView(false)
    }

    setBenefitId("");
    setLocation("");
    setLocationId("");
    setSelectedContactId("");
    setSelectedContact("")
    setLocationContacts([]);
    setCoordinatorContact("")

    setHiringManagerContactsView(false);
    setSelectedHiringManagerContactId("");

    setHiringCoordinatorContactsView(false)
    setSelectedHiringCoordinatorContactId("")

    if(!isNullOrEmpty(accountId)){
      getAccountContacts(accountId)
      setLocationContactsView(true);
    }else{
      setLocationContactsView(false);
    }
  }


  function handleAccountBenefitChange(e) {
    if (e.target.value !== "") {
      setBenefitId(e.target.value);
      setBenefitsView(true);
    } else {
      setBenefitId(e.target.value);
      setBenefitsView(false);
    }
  }



  function handleAccountContactChange (e){
    for(var i=0;i<contactDetails.length;i++){
      if(contactDetails[i].id===e.target.value){
        setSelectedContactId(contactDetails[i].firstName);

        setSelectedContact(contactDetails[i])

        return
      }
    }
    // selectedContact()
  }

  function handleAccountLocationChange(e) {
    if (e.target.value === "select location") {
      setLocation("");
      setLocationId("");
      setSelectedContactId("");
      setSelectedContact("")
      setRemoteLocation(false);
      setLocationView(false);
      setLocationContacts([]);
      setLocationContactsView(false);      
      // getAccountContacts("")   

    } else if (e.target.value === "Remote Location") {
      setRemoteLocation(true);
      setLocation(e.target.value);
      setLocationId("");
      setSelectedContactId("");
      setSelectedContact("")
      setLocationView(false);
      setLocationContactsView(true);
      // getAccountContacts(accountId)

    } else {
      setLocation(e.target.value);
      setLocationId(e.target.value);   
      setRemoteLocation(false);
      setLocationView(true);
      setLocationContactsView(true);
     // getContacts(accountId, e.target.value);
    }
  }
  const closedHandleJobRequest = () => {
    props.parentCallback("fileUpload");
  };
  const handleJobRequest = () => {
    if (id != 0) {
      updateRequest(id);
    } else {
      createJobReq();
    }
  };
  const handleJobRequestBasicinfo = () => {
    if (id != 0) {
      updateRequestBasicinfo(id);
    } else {
      createJobReqBasicinfo();
    }
  };
  const handleJobReqDetails = () => {
    if (id != 0) {
      updateRequestDetail(id);
    } else {
      createJobReqDetails();
    }
  };
  const handleJobLandingpage = () => {
    if (id != 0) {
      updateRequestLandingpage(id);
    } else {
      createJobReqLandingpage();
    }
  };
  const handleJobDescription = () => {
    if (id != 0) {
      updateRequestJobDescription(id);
    } else {
      createJobDescription();
    }
  };
  const handleJobResponsibilities = () => {
    if (id != 0) {
      updateRequestJobResponsibilities(id);
    } else {
      createJobResponsibilities();
    }
  };

  const handleJobRequirements = () => {
    if (id != 0) {
      updateRequestJobRequirements(id);
    } else {
      createJobRequirements();
    }
  };
  const handleJobBoards = () => {
    if (id != 0) {
      updateJobBoards(id);
    } else {
      createJobBoards();
    }
  };
  const createJobBoards = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };
    JobService.createJobReq(createJobReqObj).then((response) => {
      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");
        setrequestId(response.data.id);
        toast.success("JobBoardPost created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const updateJobBoards = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      // if (landingPageTemplateFields.length == 0) {
      //   toast.error("Please select template fields");
      //   return;
      // }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };
    JobService.updateJob(updateJobReqObj, jobId).then((response) => {
      try {
        var updatedJobDetails = response.data;

        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);

        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo");
        toast.success("JobBoardPost updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const goBack = () => {
    history.push("/requests");
  };
  
  const createJobReq = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts: jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };

    JobService.createJobReq(createJobReqObj).then((response) => {

      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");

        setrequestId(response.data.id);
        toast.success("Job requisition created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("fileUpload", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const createJobReqBasicinfo = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    // if (isNullOrEmpty(selectedTemplateName)) {
    //   toast.error("Please select template");
    //   return;
    // }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId
  };
 
  JobService.createJobReq(createJobReqObj).then((response) => {
      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");
        setrequestId(response.data.id);
        toast.success("Job requisition created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const createJobReqDetails = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    // if (isNullOrEmpty(selectedTemplateName)) {
    //   toast.error("Please select template");
    //   return;
    // }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };
    JobService.createJobReq(createJobReqObj).then((response) => {
      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");
        setrequestId(response.data.id);
        toast.success("Job requisition created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const createJobReqLandingpage = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
     };
    JobService.createJobReq(createJobReqObj).then((response) => {

      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");
        setrequestId(response.data.id);
        toast.success("Job requisition created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const createJobDescription = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId
    };
    JobService.createJobReq(createJobReqObj).then((response) => {
      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");
        setrequestId(response.data.id);
        toast.success("Job requisition landing page created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const createJobResponsibilities = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };
    JobService.createJobReq(createJobReqObj).then((response) => {
      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");
        setrequestId(response.data.id);
        toast.success("Job requisition created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const createJobRequirements = () => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }
    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minimum salary");
        return;
      }
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template flavor");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];

      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });

      setSchedules(schedules);
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const createJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      durationType: durationType,
      empTerm: empTerm,
      additionalPayInfo: _additionalPayInfo,
      jobShift: jobShift,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      remoteLocation: remoteLocation,
      locationId: locationId,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };
    JobService.createJobReq(createJobReqObj).then((response) => {
      try {
        var requestId = response.data.id;
        window.localStorage.setItem("requestId", requestId);
        window.localStorage.setItem("currentStatus", "OPPORTUNITY");
        setrequestId(response.data.id);
        toast.success("Job requisition created successfully");
        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo", requestId);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const getJobEnums = (overridedurationType) => {
    getEnumLists().then((response) => {
      try {
        if (response !== null) {
          let jobStatues = response.jobStatues;
          if (jobStatues != null) {
            setJobStatusOptions(jobStatues);
          }

          let priorities = response.priorities;
          if (priorities != null) {
            setJobPriorityOptions(priorities);
          }

          let salaryTypes = response.salaryTypes;
          if (salaryTypes != null) {
            setSalaryTypeOptions(salaryTypes);
          }

          let jobTypes = response.jobTypes;
          if (jobTypes != null) {
            setJobTypeOptions(jobTypes);
          }

          let jobBillingRateTypes = response.jobBillingRateTypes;
          if (jobBillingRateTypes != null) {
            setBillingRateTypes(jobBillingRateTypes);
          }
          let durationTypes = response.durationTypes;
          if (durationTypes != null) {
            setdurationTypesoptions(durationTypes);
          }

          let jobShifts = response.jobShifts;
          if (jobShifts != null) {
            setJobShiftOptions(jobShifts);
          }

          let jobRemoteWorks = response.jobRemoteWorks;
          if (jobRemoteWorks != null) {
            setJobRemoteWorkOptions(jobRemoteWorks);
          }

          let workStatues = response.workStatues;
          if (workStatues != null) {
            setWorkModelOptions(workStatues);
          }

          let jobEmpTerms = response.jobEmpTerms;
          if (jobEmpTerms != null) {
            setEmpTermOptions(jobEmpTerms);
          }

          let aboutJobs = response.aboutJobs;
          if (aboutJobs != null) {
            setAboutJobOptions(aboutJobs);
          }

          setoverridedurationTypes(overridedurationType);
        }
      } catch (err) {}
    });
  };

  const updateRequest = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template fields");
        return;
      }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts: jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };
    JobService.updateJob(updateJobReqObj, jobId).then((response) => {
      try {
        var updatedJobDetails = response.data;
        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);

        window.localStorage.setItem("add", "");
        props.parentCallback("fileUpload");
        toast.success("Job requisition updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const updateRequestBasicinfo = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template fields");
        return;
      }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };

    JobService.updateJob(updateJobReqObj, jobId).then((response) => {

      try {
        var updatedJobDetails = response.data;

        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);

        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo");
        toast.success("Job Basic Information updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const updateRequestDetail = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    // if (isNullOrEmpty(selectedTemplateName)) {
    //   toast.error("Please select template");
    //   return;
    // }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      // if (landingPageTemplateFields.length == 0) {
      //   toast.error("Please select template fields");
      //   return;
      // }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };

    JobService.updateJob(updateJobReqObj, jobId).then((response) => {
      try {
        var updatedJobDetails = response.data;

        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);

        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo");
        toast.success("Job requisition Details updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const updateRequestLandingpage = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      if (landingPageTemplateFields.length == 0) {
        toast.error("Please select template fields");
        return;
      }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId
    };

    JobService.updateJob(updateJobReqObj, jobId).then((response) => {

      try {
        var updatedJobDetails = response.data;

        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);
        setCreatedJobId(updatedJobDetails.id)

        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo");
        toast.success("Job requisition landing page updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const updateRequestJobDescription = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      // if (landingPageTemplateFields.length == 0) {
      //   toast.error("Please select template fields");
      //   return;
      // }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId
    };

    JobService.updateJob(updateJobReqObj, jobId).then((response) => {
      try {
        var updatedJobDetails = response.data;

        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);

        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo");
        toast.success("Job Description updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const updateRequestJobResponsibilities = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      // if (landingPageTemplateFields.length == 0) {
      //   toast.error("Please select template fields");
      //   return;
      // }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };

    JobService.updateJob(updateJobReqObj, jobId).then((response) => {
      try {
        var updatedJobDetails = response.data;

        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);

        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo");
        toast.success("Job Responsibilities updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const updateRequestJobRequirements = (jobId) => {
    if (inputField.jobId === "") {
      toast.error("Please enter job id");
      return;
    }
    if (inputField.jobTitle === "") {
      toast.error("Please enter job title");
      return;
    }

    if (accountId === "" || accountId === "select account") {
      toast.error("Please select account");
      return;
    }
    if (taId === "") {
      toast.error("Please select talent advisor");
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      toast.error("Please enter maximum salary");
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        toast.error("Maximum salary must be greater than minium salary");
        return;
      }
    }

    if (billingRate != 0 || billingRate != "") {
      if (!new RegExp("[0-9.]").test(billingRate)) {
        toast.error("Please enter valid salary.");
        return;
      }
    }

    if (isNullOrEmpty(selectedTemplateName)) {
      toast.error("Please select template");
      return;
    }

    if (schedule.length > 0) {
      const scheduleList = [...schedule];
      scheduleList.map((sche) => {
        schedules.push(sche.label);
      });
      setSchedules(schedules);
    }

    if (location === "Remote Location") {
      setLocationId("");
    } else {
      setLocationId(location);
    }

    let landingPageTemplateFields = [];
    if (templateFields.length > 0) {
      templateFields.map((templateField) => {
        let templateFieldName = templateField.name;
        let templateFieldValue = templateField.value;
        if (!isNullOrEmpty(templateFieldValue)) {
          const templateObject = {
            name: templateFieldName,
            value: templateFieldValue,
          };
          landingPageTemplateFields.push(templateObject);
        }
      });
      // if (landingPageTemplateFields.length == 0) {
      //   toast.error("Please select template fields");
      //   return;
      // }
    }

    let _jobTitle = "";
    if (!isNullOrEmpty(inputField.jobTitle)) {
      _jobTitle = inputField.jobTitle.trim();
    }

    let _publicTitle = "";
    if (!isNullOrEmpty(inputField.publicTitle)) {
      _publicTitle = inputField.publicTitle.trim();
    }

    let _additionalPayInfo = "";
    if (!isNullOrEmpty(additionalPayInfo)) {
      _additionalPayInfo = additionalPayInfo.trim();
    }

    const updateJobReqObj = {
      jobId: inputField.jobId,
      jobTitle: _jobTitle,
      publicTitle: _publicTitle,
      referenceId: inputField.referenceId,
      lpName: inputField.lpName,
      addTo: inputField.addTo,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      billingRate: billingRate,
      billingRateType: billingType,
      duration: inputField.duration,
      durationType: durationType,
      jobDescription: jobDescription,
      jobResponsibilities: jobResponsibilities,
      jobRequirements: jobRequirements,
      notes: inputField.notes,
      skillsFlavor: skillsFlavor,
      hiringModel: hiringModel,
      showPay: showPay,
      displayAccountInfo:displayAccInfo,
      jobStatus: jobStatus,
      priority: priority,
      salaryType: salaryType,
      jobType: jobType,
      empTerm: empTerm,
      jobShift: jobShift,
      additionalPayInfo: _additionalPayInfo,
      workStatus: workStatus,
      aboutJob: aboutJob,
      schedule: schedules,
      accountId: accountId,
      locationId: locationId,
      remoteLocation: remoteLocation,
      benefitsId: benefitsId,
      accountContactId:selectedContactId,
      talentAdvisorId: taId,
      landingPageTemplateName: selectedTemplateName,
      landingPageTemplateFields: landingPageTemplateFields,
      jobBoardPosts:jobBoardPostsUpdate,
      hiringManagerContactId:selectedHiringManagerContactId,
      hiringCoordinatorContactId :selectedHiringCoordinatorContactId,
    };
    JobService.updateJob(updateJobReqObj, jobId).then((response) => {
      try {
        var updatedJobDetails = response.data;

        setCandidateJobResponsibilities(jobResponsibilities);
        setCandidateJobRequirements(jobRequirements);
        setCandidateJobDescription(jobDescription);

        window.localStorage.setItem("add", "");
        props.parentCallback("basicInfo");
        toast.success("Job Requirements updated successfully");
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const salaryMinHandler = (e) => {
    const value = e.target.value;
    const number = value.replace(/\$|,|/g, "");
    if (number != "") {
      setSalaryMin(number);
    } else {
      setSalaryMin(e.target.value);
    }
  };
  const getAddress = (addressObj) => {
    const address = [];
    if (addressObj != null) {
      if (addressObj.street != null && addressObj.street != "") {
        address.push(addressObj.street + ", ");
      }

      if (addressObj.area != null && addressObj.area != "") {
        address.push(addressObj.area + ", ");
      }

      if (addressObj.city != null && addressObj.city != "") {
        address.push(addressObj.city + ", ");
      }

      if (addressObj.state != null && addressObj.state != "") {
        address.push(addressObj.state + ", ");
      }
      if (addressObj.country != null && addressObj.country != "") {
        address.push(addressObj.country + " ");
      }
      if (addressObj.country != null) {
        address.push(addressObj.zipcode);
      }
    }
    return address;
  };

  const displaySearchAddress = (address) => {
    return (
      <>
        <FormGroup>
          <div>{address.street !== "" && <>{address.street}</>}</div>
          <div>
            {showStreetArea(address)}{" "}
            {address.zipcode !== "" && <>{address.zipcode}</>}
          </div>
          <div>{address.country !== "" && <>{address.country}</>}</div>
        </FormGroup>
      </>
    );
  };

  const showStreetArea = (location) => {
    if (!isNullOrEmpty(location)) {
      var arr = [];
      if (!isNullOrEmpty(location.city)) {
        arr.push(location.city);
      }
      if (!isNullOrEmpty(location.state)) {
        arr.push(location.state);
      }
    }
    return arr.join(", ");
  };

  const salaryMaxHandler = (e) => {
    const value = e.target.value;
    const number = value.replace(/\$|,|/g, "");
    if (number != "") {
      setSalaryMax(number);
    } else {
      setSalaryMax(e.target.value);
    }
  };

  const showSalaryType = (salType) => {
    if (salType == "hourly") {
      return "Hourly";
    }
    if (salType == "monthly") {
      return "Monthly";
    }
    if (salType == "yearly") {
      return "Yearly";
    }
  };

  const showBillRate = (bilType) => {
    if (bilType == "hourly") {
      return "Hourly";
    }
    if (bilType == "monthly") {
      return "Monthly";
    }
    if (bilType == "yearly") {
      return "Yearly";
    }
  };

  function handleTemplateChange(e) {
    if (e.target.value == "") {
      setSelectedTemplateId("");
      setTemplateFields([]);
      setSelectedTemplateName("");
    } else {
      let tempateName = e.target.value;
      setSelectedTemplateName(tempateName);
      templates.map((template) => {
        let name = template.name;
        if (name === tempateName) {
          setSelectedTemplateId(template.id);
          let templateFields = template.fields;
          if (templateFields !== null) {
            if (templateFields.length > 0) {
              setTemplateFields([]);
              setTemplateFields(templateFields);
            } else {
              setTemplateFields([]);
            }
          }
        }
      });
    }
  }

  const showNotesList = (notes) => {
    return (
      <>
        {notes.length > 0 &&
          notes.map((note, index) => {
            return (
              <div key={note.id+index}>
                <div className="">
                  <span>
                    <Row>
                      {index === notes.length - 1 ? (
                        <>
                          <Col className="col-5">{note.fromStatus}</Col>
                        </>
                      ) : (
                        <>
                          <Col className="col-5">{note.toStatus}</Col>
                        </>
                      )}

                      <Col className="col-4">{note.days + " Days"}</Col>
                      <Col className="col-3">{note.commentedByName}</Col>
                    </Row>
                    <hr />
                    {/* rheat  {showNotes(note)} */}
                  </span>
                </div>
              </div>
            );
          })}
      </>
    );
  };

  function openNotes() {
    setIsOpen((isOpen) => !isOpen);
  }

  const displayTemplate = () => {};

  const templateInputsHandler = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...templateFields];
    list[index][name] = value;
    setTemplateFields(list);
  };

  function handleTemplateFieldsChange(e, fieldName, index) {
    let selectedEnum = e.target.value;
    if (selectedEnum == "") {
      const list = [...templateFields];
      list[index].value = "";
      setTemplateFields(list);
    } else {
      const list = [...templateFields];
      list[index].value = selectedEnum;
      setTemplateFields(list);
    }
  }

  const convertToUpperCase = (fieldName) => {
    if (isNullOrEmpty(fieldName)) {
      return "";
    } else {
      return fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
    }
  };
  return (
    <>
      <Row>
        <Colxx xxs="12" className="mt-1">
          <div>
            <div>
              <Form>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label className="lable-text">Basic Information</Label>
                    </FormGroup>
                    <Row>
                      <FormGroup className="col-xl-4 col-md-6">
                        <Colxx sm={12} className="text_account">
                          <FormGroup>
                            <Label>
                              Account*
                              {/* <span className="required-star"></span> */}
                            </Label>
                            <InputGroup>
                              <Input
                                className="t-input-group-left-radius"
                                type="select"
                                data-testid="accountId"
                                value={accountId || ""}
                                onChange={(e) => handleAccountChange(e)}
                                disabled={jobStatus == "CLOSED"}
                              >
                                <option
                                  value="select Account"
                                  className="t-rounded-lg"
                                >
                                  Select Account
                                </option>
                                {accounts.length > 0 &&
                                  accounts.map((account,index) => {
                                    return (
                                      <option
                                        key={account.id+index}
                                        value={account.id}
                                      >
                                        {account.name}
                                      </option>
                                    );
                                  })}
                              </Input>

                              {showLocation && (
                                <InputGroupAddon addonType="append" title="View Account Details">
                                  <Button
                                    className="t-input-group-right-radius"
                                    onClick={() => setModalRight1(true)}
                                    color="dark"
                                    outline
                                  >
                                    <BsFillEyeFill className="danger" />
                                  </Button>
                                </InputGroupAddon>
                              )}
                            </InputGroup>
                          </FormGroup>
                        </Colxx>

                        {accountId == "" ||
                        accountId == null ||
                        jobStatus == "CLOSED" ? (
                          <>
                            <FormGroup row>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>Location</Label>
                                  <InputGroup>
                                    <Input
                                      disabled
                                      className="t-rounded-lg"
                                      type="select"
                                      data-testid="locationId"
                                      value={location || ""}
                                      onChange={(e) =>
                                        handleAccountLocationChange(e)
                                      }
                                    >
                                      <option value="select location">
                                        Select Location
                                      </option>
                                      <option value="Remote Location">
                                        Remote Location
                                      </option>

                                      {accountLocation.length > 0 &&
                                        accountLocation.map((location,index) => {
                                          return (
                                            <option
                                              key={location.id+index}
                                              value={location.id}
                                            >
                                              {location.name}
                                            </option>
                                          );
                                        })}
                                    </Input>{" "}
                                    {locationView == true ? (
                                      <InputGroupAddon addonType="append"  title="View Location Details">
                                        {" "}
                                        <Button
                                          color="dark"
                                          outline
                                          onClick={() => setModalRight2(true)}
                                        >
                                          <BsFillEyeFill className="danger" />
                                        </Button>
                                      </InputGroupAddon>
                                    ) : (
                                      <></>
                                    )}
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>
                              <Colxx sm={12}>
                                <FormGroup>
                                <Label>Hiring Manager</Label>
                                

                                  <InputGroup >
                                  <Input disabled  type="select"> <option value="Select Account Contact" className="t-rounded-lg">
          Select Account Contact
        </option></Input>
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>

                              <Colxx sm={12}>
                                <FormGroup>
                                <Label>Hiring Coordinator</Label>
                                

                                  <InputGroup >
                                  <Input disabled  type="select"> 
                                  <option value="Select Account Contact" className="t-rounded-lg">
          Select Account Contact
        </option></Input>
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>

                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>Benefits</Label>
                                  <InputGroup>
                                    <Input
                                      className="t-rounded-lg"
                                      disabled
                                      type="select"
                                      data-testid="benefitId"
                                      value={benefitsId || ""}
                                      onChange={(e) =>
                                        handleAccountBenefitChange(e)
                                      }
                                    >
                                      <option value="">Select Benefit</option>
                                      {accountBenefits.length > 0 &&
                                        accountBenefits.map((benefit) => {
                                          return (
                                            <option
                                              key={benefit.id}
                                              value={benefit.id}
                                            >
                                              {benefit.name}
                                            </option>
                                          );
                                        })}
                                    </Input>
                                    {benefitsView === true ? (
                                      <InputGroupAddon addonType="append"  title="View Benifits Details">
                                        <Button
                                          color="dark"
                                          outline
                                          onClick={() => setModalRight(true)}
                                        >
                                          <BsFillEyeFill className="danger" />
                                        </Button>
                                      </InputGroupAddon>
                                    ) : (
                                      <></>
                                    )}
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>
                         
                             
                            
                            </FormGroup>
                          </>
                        ) : (
                          <>
                            <FormGroup row>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>Location</Label>
                                  <InputGroup>
                                    <Input
                                      className="t-input-group-left-radius"
                                      type="select"
                                      data-testid="locationId"
                                      value={location}
                                      onChange={(e) =>
                                        handleAccountLocationChange(e)
                                      }
                                    >
                                      <option
                                        key="select_location"
                                        value="select location"
                                      >
                                        Select location
                                      </option>
                                      <option
                                        key="remote_location"
                                        value="Remote Location"
                                      >
                                        Remote location
                                      </option>
                                      {accountLocation.length > 0 &&
                                        accountLocation.map((location) => {
                                          return (
                                            <option
                                              key={location.id}
                                              value={location.id}
                                            >
                                              {location.name}
                                            </option>
                                          );
                                        })}
                                    </Input>{" "}
                                    {locationView === true ? (
                                      <InputGroupAddon addonType="append" title="View Location Details">
                                        {" "}
                                        <Button
                                          className="t-input-group-right-radius"
                                          // className="simple-icon-eye"
                                          color="dark"
                                          outline
                                          onClick={() => setModalRight2(true)}
                                        >
                                          <BsFillEyeFill className="danger" />
                                        </Button>
                                      </InputGroupAddon>
                                    ) : (
                                      <></>
                                    )}
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>

                              <Colxx sm={12}>
                                <FormGroup>
                                <Label>Hiring Manager</Label>           
                                  <InputGroup>
                                   <HiringManagerContacts                                    
                                   parentCallback={jobReqHiringManagerPost}
                                   locationContacts={accountContactsList}
                                   selectedHiringManagerContact={selectedHiringManagerContact}
                                  //  selectedContactId={selectedContactId}
                                   hiringManagerContactsView={hiringManagerContactsView}
                                   jobDetailsAccountId={jobDetailsAccountId} 
                                   selectedHiringManagerContactId={selectedHiringManagerContactId}
                                   />
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>


                              <Colxx sm={12}>
                                <FormGroup>
                                <Label>Hiring Coordinator</Label>           
                                  <InputGroup>
                                  <HiringCoordinatorContacts                                    
                                   parentCallback={jobReqHiringCoordinatorPost}
                                   locationContacts={accountContactsList}
                                   selectedHiringCoordinatorContact={selectedHiringCoordinatorContact}
                                   hiringCoordinatorContactsView={hiringCoordinatorContactsView}
                                   jobDetailsAccountId={jobDetailsAccountId} 
                                   selectedHiringCoordinatorContactId={selectedHiringCoordinatorContactId}
                                   />


                                   {/* <JobReqLocation                                    
                                   locationId = {locationId}
                                   parentCallback={jobReqCoordinatorpost}
                                   jobStatus={jobStatus}
                                   locationContacts={locationContacts}
                                   selectedContact={selectedContact}
                                   selectedContactId={coordinatorContact}
                                   locationContactsView={locationContactsView}
                                   
                                   /> */}
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>

                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>Benefits</Label>
                                  <InputGroup>
                                    <Input
                                      className="t-input-group-left-radius"
                                      type="select"
                                      data-testid="benefitId"
                                      value={benefitsId}
                                      onChange={(e) =>
                                        handleAccountBenefitChange(e)
                                      }
                                    >
                                      <option value=""> Select benefit </option>

                                      {accountBenefits.length > 0 &&
                                        accountBenefits.map((benefit) => {
                                          return (
                                            <option
                                              key={benefit.id}
                                              value={benefit.id}
                                            >
                                              {benefit.name}
                                            </option>
                                          );
                                        })}
                                    </Input>
                                    {benefitsView === true ? (
                                      <InputGroupAddon addonType="append"  title="View Benifits Details">
                                        <Button
                                          className="t-input-group-right-radius"
                                          color="dark"
                                          outline
                                          onClick={() => setModalRight(true)}
                                        >
                                          <BsFillEyeFill className="danger" />
                                        </Button>
                                      </InputGroupAddon>
                                    ) : (
                                      <></>
                                    )}
                                  </InputGroup>
                                </FormGroup>
                              </Colxx>
                             
                             
                              

                             
                            </FormGroup>
                          </>
                        )}
                      </FormGroup>
                      <FormGroup className="col-xl-4 col-md-6">
                        <Colxx>
                          <FormGroup>
                            <Label>
                              Job ID*
                              {/* <span className="required-star"></span> */}
                            </Label>
                            <InputGroup>
                              <Input
                                className="t-input-group-left-radius"
                                id="jobId"
                                type="jobId"
                                name="jobId"
                                onChange={inputsHandler}
                                value={inputField.jobId}
                                disabled={jobStatus == "CLOSED"}
                              />
                              <InputGroupAddon addonType="append">
                                <Button
                                  outline
                                  className="t-input-group-right-radius"
                                  color="dark"
                                  onClick={getGeneratedJobId}
                                  disabled={jobStatus == "CLOSED"}
                                >
                                  <GrSettingsOption className="danger" />
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                        </Colxx>
                        <Colxx>
                          <FormGroup>
                            <Label>
                              Job Title*
                              {/* <span className="required-star"></span> */}
                            </Label>
                            <Input
                              id="jobTitle"
                              type="jobTitle"
                              name="jobTitle"
                              onChange={inputsHandler}
                              value={inputField.jobTitle}
                              disabled={jobStatus == "CLOSED"}
                              className="form-control t-rounded-lg"
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx>
                          <FormGroup>
                            <Label>Public Title</Label>
                            <Input
                              id="publicTitle"
                              type="publicTitle"
                              name="publicTitle"
                              onChange={inputsHandler}
                              value={inputField.publicTitle}
                              disabled={jobStatus == "CLOSED"}
                              className="form-control t-rounded-lg"
                            />
                          </FormGroup>
                        </Colxx>


                        {accountId == "" ||
                        accountId == null ||
                        jobStatus == "CLOSED" ? (
<>
                        <Colxx sm={12}>
                                <FormGroup>
                                  <Label>Account Reference ID</Label>
                                  <Input
                                  disabled
                                
                                  />
                                </FormGroup>
                              </Colxx>
                       </> ):(<><Colxx sm={12}>
                                <FormGroup>
                                  <Label>Account Reference ID</Label>
                                  <Input
                                    id="referenceId"
                                    type="referenceId"
                                    name="referenceId"
                                    onChange={inputsHandler}
                                    value={inputField.referenceId}
                                    className="form-control t-rounded-lg"
                                  />
                                </FormGroup>
                              </Colxx></>)}
                       
                      </FormGroup>
                      <FormGroup className="col-xl-4 col-md-6">
                        <Colxx className="p-0">
                          <FormGroup>
                            <Label>Job Requisition Status</Label>

                            <InputGroup>
                              <Input
                                disabled
                                className=" t-input-group-left-radius"
                                // type="select"
                                id="jobStatus"
                                value={jobReqStatus}
                                onChange={(e) => handleJobStatusSelectChange(e)}
                              >
                                {jobStatusOptions.map(({ value, key }) => (
                                  <option value={key} key={key}>{value}</option>
                                ))}
                              </Input>
                              <InputGroupAddon addonType="append">
                                {" "}
                                <Button
                                  className="t-input-group-right-radius "
                                  onClick={openNotes}
                                >
                                  <AiOutlineCaretDown className="" />
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>

                            {isOpen && (
                              <Card className="t-toggle-z-index ">
                                <div className="p-3">
                                  {showNotesList(notesList)}
                                </div>
                              </Card>
                            )}
                          </FormGroup>
                        </Colxx>

                        <Colxx className="p-0">
                          <FormGroup>
                            <Label>Hiring Decisionmaker</Label>
                            <Input
                              className="t-rounded-lg"
                              type="select"
                              id="hiringModel"
                              value={hiringModel}
                              disabled={jobStatus == "CLOSED"}
                              onChange={handleHiringModelSelectChange}
                            >
                              <option value={" Small office"}>
                                Small office - all reviewers share the same vote
                                and decision
                              </option>
                              <option value={"Enterprise"}>
                                Enterprise - multiple reviewers, one
                                decisionmaker
                              </option>
                            </Input>
                          </FormGroup>
                        </Colxx>

                        <Colxx className="p-0">
                          <FormGroup>
                            <Label>Priority</Label>

                            <Input
                              className="t-rounded-lg"
                              type="select"
                              value={priority}
                              id="priority"
                              disabled={jobStatus == "CLOSED"}
                              onChange={(e) => handlePrioritySelectChange(e)}
                            >
                              {jobPriorityOptions.map(({ value, key }) => (
                                <option value={key} key={key}>{value}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Colxx>



                        <Colxx className="p-0">
                          <FormGroup>
                            <Label>
                              Talent Advisor*
                              {/* <span className="required-star"></span> */}
                            </Label>
                            <Input
                              id=""
                              type="select"
                              name="publicTitle"
                              onChange={(e) => {
                                handleTAChange(e);
                              }}
                              value={taId || ""}
                              disabled={jobStatus == "CLOSED"}
                              className="form-control t-rounded-lg"
                            >
                              <option value={""}>{"Select TA"}</option>
                              {talentAdvisor.map((ta,index) => (
                                <option value={ta.value} key={index}>{ta.label}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Colxx>


                      </FormGroup>
                    </Row>
                    {jobStatus != "CLOSED" && (
                      <Button
                        className="ml-2 my-2 basic_Savebutton btn-sm"
                        color="primary"
                        outline
                        onClick={handleJobRequestBasicinfo}
                      >
                        Save
                      </Button>
                    )}
                  </CardBody>
                </Card>

                <hr />

                <Card>
                  <CardBody>
                    <FormGroup row>
                      <Colxx sm={6}>
                        <Label className="lable-text">
                          Job Requisition Details
                        </Label>
                      </Colxx>
                    </FormGroup>

                    <FormGroup row>
                      <Colxx className=" col-xl-2 col-md-4 col-sm-6">
                        <FormGroup>
                          <Label>Salary Minimum</Label>
                          <CurrencyFormat
                            className="t-rounded-lg"
                            customInput={Input}
                            onChange={salaryMinHandler}
                            value={salaryMin}
                            decimalScale={2}
                            thousandSeparator={true}
                            prefix={"$"}
                            disabled={jobStatus == "CLOSED"}
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx className="col-xl-2 col-md-4 col-sm-6">
                        <FormGroup>
                          <Label>Salary Maximum</Label>

                          <CurrencyFormat
                            // id="salaryMax"
                            //type="number"
                            className="t-rounded-lg"
                            customInput={Input}
                            //format="###,###,###,###"
                            // value={2456981}
                            onChange={salaryMaxHandler}
                            decimalScale={2}
                            value={salaryMax}
                            thousandSeparator={true}
                            prefix={"$"}
                            disabled={jobStatus == "CLOSED"}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Salary Type</Label>

                          <Input
                            type="select"
                            className="t-rounded-lg"
                            id="salaryType"
                            value={salaryType || ""}
                            disabled={jobStatus == "CLOSED"}
                            onChange={(e) => handleSlaryTypeSelectChange(e)}
                          >
                            {salaryTypeOptions.map(({ value, key }) => (
                              <option value={key} key={key}>
                                {showSalaryType(value)}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Colxx>
                      <Colxx md={4}>
                        <Label>Additional Pay Info</Label>

                        <Input
                          id="billingRate"
                          className="t-rounded-lg"
                          onChange={handleAdditionalPayInfo}
                          value={additionalPayInfo}
                        />
                      </Colxx>
                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Bill Rate</Label>

                          <CurrencyFormat
                            className="t-rounded-lg"
                            id="billingRate"
                            customInput={Input}
                            onChange={handleBillingRate}
                            value={billingRate}
                            decimalScale={2}
                            thousandSeparator={true}
                            prefix={"$"}
                            disabled={jobStatus == "CLOSED"}
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Bill Rate Type</Label>

                          <Input
                            className="t-rounded-lg"
                            type="select"
                            id="billingType"
                            value={billingType || ""}
                            disabled={jobStatus == "CLOSED"}
                            onChange={(e) => handleBillingTypeSelectChange(e)}
                          >
                            {billingRateTypes.map(({ value, key }) => (
                              <option value={key} key={key}>{showBillRate(value)}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Colxx>
                    </FormGroup>
                    <hr />

                    <FormGroup row>
                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Job Type</Label>

                          <Input
                            className="t-rounded-lg"
                            type="select"
                            id="overrideJobType"
                            value={jobType}
                            disabled={jobStatus == "CLOSED"}
                            onChange={(e) => handleJobTypeSelectChange(e)}
                          >
                            {jobTypeOptions.map(({ value, key }) => (
                              <option value={key} key={key}>{value}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Colxx>

                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Employment Terms</Label>

                          <Input
                            className="t-rounded-lg"
                            type="select"
                            id="empTerm"
                            value={empTerm}
                            disabled={jobStatus == "CLOSED"}
                            onChange={(e) =>
                              handleEmployeementTermSelectChange(e)
                            }
                          >
                            {empTermOptions.map(({ value, key }) => (
                              <option value={key} key={key}>{value}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Colxx>

                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Job Shift</Label>

                          <Input
                            className="t-rounded-lg"
                            type="select"
                            id="overJobShift"
                            value={jobShift || ""}
                            disabled={jobStatus == "CLOSED"}
                            onChange={(e) => handleJobShiftSelectChange(e)}
                          >
                            {jobShiftOptions.map(({ value, key }) => (
                              <option value={key} key={key}>{value}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Colxx>
                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Work Model</Label>

                          <Input
                            className="t-rounded-lg"
                            type="select"
                            id="remoteWork"
                            value={workStatus || ""}
                            disabled={jobStatus == "CLOSED"}
                            onChange={(e) => handleWorkModelChange(e)}
                          >
                            {workModelOptions.map(({ value, key }) => (
                              <option value={key} key={key}>{value}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Colxx>

                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Duration</Label>
                          <InputGroup>
                            <Input
                              id="duration"
                              type="number"
                              name="duration"
                              onChange={inputsHandler}
                              value={inputField.duration}
                              disabled={jobStatus == "CLOSED"}
                              className="form-control t-input-group-left-radius"
                            />
                            <InputGroupAddon addonType="append">
                              <Input
                                className="t-input-group-right-radius"
                                type="select"
                                value={durationType}
                                disabled={jobStatus == "CLOSED"}
                                onChange={(e) =>
                                  handledurationtypeSelectChange(e)
                                }
                              >
                                {durationTypesoptions.map(({ value, key }) => (
                                  <option value={key} key={key}>{value}</option>
                                ))}
                              </Input>
                            </InputGroupAddon>{" "}
                          </InputGroup>
                        </FormGroup>
                      </Colxx>

                      <Colxx md={4}>
                        <FormGroup>
                          <Label>Schedule</Label>

                          {(() => {
                            if (schedule.length > 0) {
                              return (
                                <Select
                                  id="schedule"
                                  closeMenuOnSelect={false}
                                  isMulti
                                  placeholder="Select Schedule"
                                  className="req_dropdown t-rounded-lg"
                                  value={schedule || ""}
                                  options={scheduleType}
                                  isDisabled={jobStatus == "CLOSED"}
                                  onChange={(event) =>
                                    handleScheduleClick(event)
                                  }
                                />
                              );
                            } else {
                              return (
                                <Select
                                  id="schedule"
                                  closeMenuOnSelect={false}
                                  isMulti
                                  placeholder="Select Schedule"
                                  className="req_dropdown t-rounded-lg"
                                  options={scheduleType}
                                  value={schedule || ""}
                                  //disabled = {jobStatus == "CLOSED"}
                                  isDisabled={jobStatus == "CLOSED"}
                                  onChange={(event) =>
                                    handleScheduleClick(event)
                                  }
                                />
                              );
                            }
                          })()}
                        </FormGroup>
                      </Colxx>
                    </FormGroup>
                    {jobStatus != "CLOSED" && (
                      <>
                        {!isNullOrEmpty(inputField.jobId) && (
                          <Button
                            className="ml-2 my-2 basic_Savebutton btn-sm"
                            color="primary"
                            outline
                            onClick={handleJobReqDetails}
                          >
                            Save
                          </Button>
                        )}
                      </>
                    )}
                  </CardBody>
                </Card>

                <hr />

                <Row>
                  <Col sm={6} md={6}>
                    <Card className="mb-3 t-jobPost-card t-postcard-scroll">
                     
                        <Label className="lable-text mt-3 ml-3">Landing Page</Label>
                      <CardBody className="py-2">
                        <Row>
                          <FormGroup className="col-md-12 col-xl-12 ">
                            <div className="row">
                              <Label className="col-sm-9 col-xl-7 col-form-label">
                                Show Salary on Job Requisition Page
                              </Label>
                              <div className="col-sm-4 col-xl-4">
                                <div className="col-sm-8">
                                  <label className="switch">
                                    <input
                                      className="t-rounded-lg"
                                      type="checkbox"
                                      disabled={jobStatus == "CLOSED"}
                                      checked={showPay}
                                      onChange={handleShowPaySelectChange}
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                          <span className="col-md-12 col-xl-12">
                            <div className="row">
                              <Label className="col-sm-9 col-xl-7 col-form-label ">
                                Show Account details on Job Requisition Page
                              </Label>
                              <div className="col-sm-5 col-xl-4">
                                <div className="col-sm-8">
                                  <label className="switch">
                                    <input
                                      className="t-rounded-lg"
                                      type="checkbox"
                                      disabled={jobStatus == "CLOSED"}
                                      checked={displayAccInfo}
                                      onChange={handleDisplayAccSelectChange}
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </span>
                        </Row>

                        <Row className="mt-3">
                          <span className="col-md-8 col-xl-6">
                            <Colxx sm={12} className="text_account">
                              <FormGroup>
                                <Label>Template*</Label>
                                <InputGroup>
                                  <Input
                                    className="t-rounded-lg"
                                    type="select"
                                    data-testid="templateId"
                                    value={selectedTemplateName || ""}
                                    onChange={(e) => handleTemplateChange(e)}
                                    disabled={jobStatus == "CLOSED"}
                                  >
                                    <option value="">Select Template</option>
                                    {templates.length > 0 &&
                                      templates.map((template) => {
                                        return (
                                          <option
                                            key={template.id}
                                            value={template.name}
                                          >
                                            {template.name}
                                          </option>
                                        );
                                      })}
                                  </Input>
                                </InputGroup>
                              </FormGroup>
                            </Colxx>
                          </span>
                        </Row>

                        {isNullOrEmpty(selectedTemplateName) ? (
                          <></>
                        ) : (
                          <Row>
                            {templateFields.length > 0 &&
                              templateFields.map((templateField, index) => {
                                const { value } = templateField;
                                return (
                                  <Colxx className="col-md-8 col-xl-6" key={index}>
                                      <Label>
                                        {" "}
                                        {convertToUpperCase(templateField.name)}
                                      </Label>
                                      *
                                      {templateField.type !== "ENUM" ? (
                                        <input
                                          type="text"
                                          onChange={(evnt) =>
                                            templateInputsHandler(index, evnt)
                                          }
                                          value={value}
                                          name="value"
                                          className="form-control t-rounded-lg"
                                        />
                                      ) : (
                                        <></>
                                      )}
                                      {templateField.type == "ENUM" &&
                                        templateField.enumValues.length > 0 && (
                                          <>
                                            <InputGroup>
                                              <Input
                                                className="t-rounded-lg"
                                                type="select"
                                                data-testid="flavor"
                                                value={
                                                  templateField.value || ""
                                                }
                                                onChange={(e) =>
                                                  handleTemplateFieldsChange(
                                                    e,
                                                    templateField.name,
                                                    index
                                                  )
                                                }
                                              >
                                                <option value="">
                                                  Select Flavor
                                                </option>
                                                {templateField.enumValues
                                                  .length > 0 &&
                                                  templateField.enumValues.map(
                                                    (enumVal,index) => {
                                                      return (
                                                        <option key={index}>
                                                          {enumVal}
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                              </Input>{" "}
                                            </InputGroup>
                                          </>
                                        )}
                                   
                                  </Colxx>
                                );
                              })}
                          </Row>
                        )}
                        {jobStatus != "CLOSED" && (
                          <>
                            {!isNullOrEmpty(inputField.jobId) && (
                              <Button
                                className="ml-2 my-2 mt-4 basic_Savebutton btn-sm"
                                color="primary"
                                outline
                                onClick={handleJobLandingpage}
                              >
                                Save
                              </Button>
                            )}
                          </>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                    <Col sm={6} md={6}>
                    <Card className="t-jobPost-card t-postcard-scroll">
                          <JobBoardPost
                          parentCallback={jobBoardPostFunction}
                          jobStatus={jobStatus}
                          updateJobBoard={jobBoardPostsUpdate}

                          />
                                  {jobStatus != "CLOSED" && (
                                            <>
                                              {!isNullOrEmpty(inputField.jobId) && (
                                                <Row>
                                                  <Col sm={3}>
                                                <Button
                                                  className="ml-5 mt-5 btn-sm"
                                                  color="primary"
                                                  outline
                                                  onClick={handleJobBoards}
                                                >
                                                  Save
                                                </Button>
                                                </Col>
                                                </Row>
                                              )}
                                            </>
                                          )}
                          </Card>
                      </Col>
                </Row>

                <Row className=" ">
                  <Colxx xxs="12">
                    <Card>
                      <CardBody>
                        <div className="row ">
                          <label htmlFor="Horizontal" className="col-6">
                            Job Description
                          </label>
                          <div className="col-6 t-button-flex-end mb-1">
                            {/* <Button className="ml-2  basic_Savebutton btn-sm"
                          color="primary"
                          outline onClick={jobDescriptionFunction}> Undo</Button> */}
                          </div>

                          <div className="col-12">
                            <ReactQuill
                              id="jobDescription"
                              theme="snow"
                              value={jobDescription}
                              readOnly={jobStatus === "CLOSED"}
                              preserveWhitespace={true}
                              onChange={(val) => setJobDescription(val)}
                              modules={quillModules}
                              formats={quillFormats}
                            />
                          </div>

                          {/* <EditorToolbar /> */}
                        </div>

                        {jobStatus != "CLOSED" && (
                          <>
                            {!isNullOrEmpty(inputField.jobId) && (
                              <Button
                                className="ml-2 my-2 basic_Savebutton btn-sm"
                                color="primary"
                                outline
                                onClick={handleJobDescription}
                              >
                                Save
                              </Button>
                            )}
                          </>
                        )}
                        <Button
                          className="ml-2 my-2 basic_Savebutton btn-sm"
                          color="primary"
                          outline
                          onClick={jobDescriptionFunction}
                        >
                          {" "}
                          Undo
                        </Button>
                      </CardBody>
                    </Card>
                  </Colxx>
                </Row>

                <Colxx sm={8}>
                  <FormGroup></FormGroup>
                </Colxx>

                <Row className="">
                  <Colxx xxs="12">
                    <Card>
                      <CardBody>
                        <div className="row ">
                          <label htmlFor="Horizontal" className="col-6">
                            Job Responsibilities
                          </label>

                          <div className="col-6 t-button-flex-end mb-1">
                            {/* <Button className="ml-2  basic_Savebutton btn-sm"
                          color="primary"
                          outline onClick={jobResponsibilitiesFunction}> Undo</Button> */}
                          </div>

                          <div className="col-12">
                            {/* <EditorToolbar/> */}
                            <ReactQuill
                              className="t-rounded-lg"
                              id="jobResponsibilities"
                              theme="snow"
                              value={jobResponsibilities}
                              preserveWhitespace={true}
                              onChange={(val) => setJobResponsibilities(val)}
                              modules={quillModules}
                              formats={quillFormats}
                              readOnly={jobStatus === "CLOSED"}
                            />
                          </div>
                        </div>

                        {jobStatus != "CLOSED" && (
                          <>
                            {!isNullOrEmpty(inputField.jobId) && (
                              <Button
                                className="ml-2 my-2 basic_Savebutton btn-sm"
                                color="primary"
                                outline
                                onClick={handleJobResponsibilities}
                              >
                                Save
                              </Button>
                            )}
                          </>
                        )}
                        <Button
                          className="ml-2 my-2 basic_Savebutton btn-sm"
                          color="primary"
                          outline
                          onClick={jobResponsibilitiesFunction}
                        >
                          {" "}
                          Undo
                        </Button>
                      </CardBody>
                    </Card>
                  </Colxx>
                </Row>

                <Colxx sm={8}>
                  <FormGroup></FormGroup>
                </Colxx>

                <Row className="">
                  <Colxx xxs="12">
                    <Card>
                      <CardBody>
                        <div className="row">
                          <label htmlFor="Horizontal" className="col-6 ">
                            Job Requirements
                          </label>

                          <div className="col-6 t-button-flex-end mb-1">
                            {/* <Button className="ml-2  basic_Savebutton btn-sm"
                          color="primary"
                          outline onClick={jobRequirementsFunction}> Undo</Button> */}
                          </div>

                          <div className="col-12">
                            {/* <EditorToolbar/> */}
                            <ReactQuill
                              className="t-rounded-lg"
                              id="jobRequirements"
                              theme="snow"
                              value={jobRequirements}
                              preserveWhitespace={true}
                              onChange={(val) => setJobRequirements(val)}
                              modules={quillModules}
                              formats={quillFormats}
                              readOnly={jobStatus === "CLOSED"}
                            />
                          </div>
                        </div>

                        {jobStatus != "CLOSED" && (
                          <>
                            {!isNullOrEmpty(inputField.jobId) && (
                              <Button
                                className="ml-2 my-2 basic_Savebutton btn-sm"
                                color="primary"
                                outline
                                onClick={handleJobRequirements}
                              >
                                Save
                              </Button>
                            )}
                          </>
                        )}
                        <Button
                          className="ml-2 my-2 basic_Savebutton btn-sm"
                          color="primary"
                          outline
                          onClick={jobRequirementsFunction}
                        >
                          {" "}
                          Undo
                        </Button>
                      </CardBody>
                    </Card>
                  </Colxx>
                </Row>

                <Colxx sm={8}>
                  <FormGroup></FormGroup>
                </Colxx>

                <Colxx sm={8}>
                  <FormGroup></FormGroup>
                </Colxx>

                <FormGroup row>
                  <Colxx>
                    <Button color="primary" size="sm" onClick={goBack} outline>
                      <MdOutlineArrowBackIosNew />
                    </Button>
                    {jobStatus != "CLOSED" ? (
                      <>
                        <Button
                          className="ml-2  basic_Savebutton btn-sm"
                          color="primary"
                          outline
                          onClick={handleJobRequest}
                        >
                          Save and next
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          className="ml-2  basic_Savebutton"
                          color="primary"
                          outline
                          onClick={closedHandleJobRequest}
                        >
                          Next
                        </Button>
                      </>
                    )}
                  </Colxx>

                  <Colxx></Colxx>
                </FormGroup>

                <Row className="col-12">
                  <div></div>
                </Row>
              </Form>
            </div>
          </div>
        </Colxx>
      </Row>

      <div>
        <div>
          <Modal
            isOpen={modalRight1}
            toggle={() => setModalRight1(!modalRight1)}
            wrapClassName="modal-right"
            className="W-400"
          >
            <ModalHeader>
              <strong>Account details</strong>
            </ModalHeader>
            <ModalBody>
              {accounts.map((account,index) => {
                if (accountId == account.id) {
                  return (
                    <div key={index}>
                      <Row className="">
                        <Colxx sm={4}>
                          <Label>Name</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          <b>{account.name}</b>
                        </Colxx>
                      </Row>
                      <Row className="mt-1">
                        <Colxx sm={4}>
                          <Label>Short code</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          <b>{account.shortCode}</b>
                        </Colxx>
                      </Row>
                      <Row className="mt-1">
                        <Colxx sm={4}>
                          <Label>Email</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          {!isNullOrEmpty(account.primaryContact) ? (
                            <>
                              <b
                                className="t-cursor-pointer"
                                title="Primary Contact"
                              >
                                {account.primaryContact.email}
                              </b>
                            </>
                          ) : (
                            <></>
                          )}
                        </Colxx>
                      </Row>
                      <Row className="mt-1">
                        <Colxx sm={4}>
                          <Label>Mobile Number</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          {!isNullOrEmpty(account.primaryContact) ? (
                            <>
                              <strong
                                className="t-cursor-pointer"
                                title="Primary Contact"
                              >
                                {formattedMobileNumber(
                                  account.primaryContact.mobileNumber
                                )}
                              </strong>
                            </>
                          ) : (
                            <></>
                          )}
                        </Colxx>
                      </Row>
                    </div>
                  );
                }
              })}
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                size="sm"
                onClick={() => setModalRight1(false)}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>

      <div>
        <div>
          <Modal
            isOpen={modalRight2}
            toggle={() => setModalRight2(!modalRight2)}
            wrapClassName="modal-right"
            className="W-400"
          >
            <ModalHeader>
              <strong>Location Details</strong>
            </ModalHeader>
            <ModalBody>
              {accountLocation.map((location,index) => {
                if (locationId == location.id) {
                  return (
                    <div key={index}>
                      <Row className="">
                        <Colxx sm={4}>
                          <Label>Name</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          <b>{location.name}</b>
                        </Colxx>
                      </Row>
                      <Row className="mt-1">
                        <Colxx sm={4}>
                          <Label>Email</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          {!isNullOrEmpty(location.primaryContacts) ? (
                            <>
                              <b
                                className="t-cursor-pointer"
                                title="Primary Contact"
                              >
                                {location.primaryContacts[0].email}
                              </b>
                            </>
                          ) : (
                            <></>
                          )}
                        </Colxx>
                      </Row>
                      <Row className="mt-1">
                        <Colxx sm={4}>
                          <Label>Mobile Number</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          {!isNullOrEmpty(location.primaryContacts) ? (
                            <>
                              <b
                                className="t-cursor-pointer"
                                title="Primary Contact"
                              >
                                {formattedMobileNumber(
                                  location.primaryContacts[0].mobileNumber
                                )}
                              </b>
                            </>
                          ) : (
                            <></>
                          )}
                        </Colxx>
                      </Row>
                      <Row className="mt-1">
                        <Colxx sm={4}>
                          <Label>Location</Label> :
                        </Colxx>
                        <Colxx sm={8}>
                          {location.address !== null && (
                            <b>
                              <Label>
                                {displaySearchAddress(location.address)}
                              </Label>
                            </b>
                          )}
                        </Colxx>
                      </Row>
                    </div>
                  );
                }
              })}
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                size="sm"
                onClick={() => setModalRight2(false)}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>

      <div>
        <div>
          <Modal
            scrollable={true}
            isOpen={modalRight}
            toggle={() => setModalRight(!modalRight)}
            wrapClassName="modal-right"
            className="skill-model-width"
          >
            {accountBenefits.map((benifits,index) => {
              if (benefitsId == benifits.id) {
                return (
                  <div key={index}>
                    <ModalHeader className="benefitmodal_header">
                      {" "}
                      <h2>
                        <strong> {benifits.name}</strong>
                      </h2>
                    </ModalHeader>
                    <ModalBody>
                      <div className="Container-box">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="barmenu_content barmenu_content_active">
                              <div className="addexperience right">
                                <Form>
                                  <Colxx sm={12}>
                                    <h5 className="benefit_types">Mandated</h5>
                                  </Colxx>
                                  <Colxx sm={12}>
                                    <div className="row form-group">
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              type="checkbox"
                                              data-testid="account-cobra"
                                              className="custom-control-input"
                                              name="cobra"
                                              checked={benifits.cobra}
                                            />
                                            <div className="custom-control-label">
                                              COBRA
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              type="checkbox"
                                              checked={benifits.disability}
                                              data-testid="account-disability"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Disability
                                            </div>
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.minimumWage}
                                              type="checkbox"
                                              data-testid="account-minimumWage"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Minimum Wage
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.overtime}
                                              type="checkbox"
                                              data-testid="account-overtime"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Overtime
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={
                                                benifits.unEmploymentBenefit
                                              }
                                              type="checkbox"
                                              data-testid="account-unEmploymentBenefit"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Unemployment Benefits
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={
                                                benifits.workerCompensation
                                              }
                                              type="checkbox"
                                              data-testid="account-workerCompensation"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Workers Compensation
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-7">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              type="checkbox"
                                              checked={benifits.medicalLeave}
                                              data-testid="account-medicalLeave"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Family and Medical Leave Act
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </Colxx>
                                  <Colxx sm={12} className="border-top pt-1">
                                    <h5 className="benefit_types">
                                      Compensation
                                    </h5>
                                  </Colxx>
                                  <Colxx sm={12}>
                                    <div className="row form-group">
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.bonusPay}
                                              type="checkbox"
                                              data-testid="account-bonusPay"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label row-sm-4">
                                              Bonus Pay
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={
                                                benifits.compensation401k
                                              }
                                              type="checkbox"
                                              data-testid="account-compensation401k"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              401k
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.stockOption}
                                              type="checkbox"
                                              data-testid="account-stockOption"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Stock options
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </Colxx>
                                  <Colxx sm={12} className="border-top pt-1">
                                    <h5 className="benefit_types">Insurance</h5>
                                  </Colxx>
                                  <Colxx sm={12}>
                                    <div className="row form-group">
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.health}
                                              type="checkbox"
                                              data-testid="account-health"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Health
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.dental}
                                              type="checkbox"
                                              data-testid="account-dental"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Dental
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.vision}
                                              type="checkbox"
                                              data-testid="account-vision"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Vision
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.lifeInsurance}
                                              type="checkbox"
                                              data-testid="account-lifeInsurance"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Life Insurance
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </Colxx>
                                  <Colxx sm={12} className="border-top pt-1">
                                    <h5 className="benefit_types">
                                      {" "}
                                      Paid Time Off
                                    </h5>
                                  </Colxx>
                                  <Colxx sm={12}>
                                    <div className="row form-group">
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.paidHoliday}
                                              type="checkbox"
                                              data-testid="account-paidHoliday"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label row-sm-4">
                                              Paid Holidays
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.paidSickTime}
                                              type="checkbox"
                                              data-testid="account-paidSickTime"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Paid Sick Time
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.paidVacation}
                                              type="checkbox"
                                              data-testid="account-paidVacation"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Paid Vacation
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.flexibleHour}
                                              type="checkbox"
                                              data-testid="account-flexibleHour"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Flexible Hours
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.parentalLeave}
                                              type="checkbox"
                                              data-testid="account-parentalLeave"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Parental Leave
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </Colxx>

                                  <Colxx sm={12} className="border-top pt-1">
                                    <h5 className="benefit_types">
                                      Employee Savings
                                    </h5>
                                  </Colxx>
                                  <Colxx sm={12}>
                                    <div className="row form-group">
                                      <div className="col-sm-4">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.empDiscount}
                                              type="checkbox"
                                              data-testid="account-tempDiscount"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Employee Discounts
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </Colxx>
                                  <Colxx sm={12} className="border-top pt-1">
                                    <h5 className="benefit_types">Education</h5>
                                  </Colxx>
                                  <Colxx sm={12}>
                                    <div className="row form-group">
                                      <div className="col-sm-6">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={
                                                benifits.profDeveAssistance
                                              }
                                              type="checkbox"
                                              data-testid="account-profDeveAssistance"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Professional Development
                                              Assistance
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-sm-6">
                                        <div className="custom-checkbox custom-control custom-control-inline">
                                          <label>
                                            <input
                                              checked={benifits.tuition}
                                              type="checkbox"
                                              data-testid="account-tuition"
                                              className="custom-control-input"
                                            />
                                            <div className="custom-control-label">
                                              Tution Reimbursement
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </Colxx>
                                  <Colxx sm={12} className="border-top pt-1">
                                    <h5 className="benefit_types">
                                      Additional Benefits
                                    </h5>
                                  </Colxx>

                                  <Colxx sm={12} className="">
                                    <div>
                                      <ul>
                                        {!isNullOrEmpty(benifits.perks) &&
                                          benifits.perks.map((adlBenebits,index) => (
                                            <li key={index}>{adlBenebits}</li>
                                          ))}
                                      </ul>
                                    </div>
                                  </Colxx>
                                </Form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                  </div>
                );
              }
            })}

            <ModalFooter>
              <Button
                color="secondary"
                size="sm"
                onClick={() => setModalRight(false)}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>

          <Modal
            scrollable={true}
            isOpen={baseModalright}
            toggle={() => setBaseModalRight(!baseModalright)}
            wrapClassName="modal-right"
            className="skill-model-width"
          >
           
              
                  <>
                    <ModalHeader className="benefitmodal_header">
                      {" "}
                      <h2>
                        <strong> {selectedContact.firstName}</strong>
                      </h2>
                    </ModalHeader>
                    <ModalBody>
                    {selectedContact.email}
                    </ModalBody>
                  </>
        
            <ModalFooter>
              <Button
                color="secondary"
                size="sm"
                onClick={() => setBaseModalRight(false)}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default BasicInformation;